<template>
  <div class="mb-2" v-if="tags && tags.length">
    <strong class="chip-title pr-1">{{ title }}</strong>

    <template v-if="type == 'fandom'">
      <span class="chip chip-fandom" :key="tag" v-for="tag in sortedTags">
        <router-link :to="`/${exchangeId}/fandom/${encodeURIComponent(tag)}`">{{ tag }}</router-link></span>

    </template>
    <template v-else>
      <span class="chip" :key="tag" v-for="tag in sortedTags">{{ tag }}</span>
    </template>
    <template v-if="truncate">
      <button v-if="truncateTags && tags.length > Number(limit)" class="chip btn-expand"
        @click="truncateTags = !truncateTags">Show all {{ tags.length }} tags</button>
      <button v-if="!truncateTags && tags.length > Number(limit)" class="chip btn-collapse"
        @click="truncateTags = !truncateTags">Show fewer tags</button>
    </template>

  </div>
</template>

<script>
import { sortBy, truncate } from "lodash-es";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    tags: {
      type: Array,
      default() {
        return [];
      },
    },
    truncate: {
      type: Boolean,
      default: false
    },
    limit: {
      type: [Number, String],
      default: 10
    },
    type: {
      type: String,
      default: ""
    },
    exchangeId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      truncateTags: false
    }
  },
  beforeMount() {
    if (this.truncate) {
      this.truncateTags = true;
    }
  },
  watch: {
    truncate(val, oldVal) {
      if (val !== oldVal) {
        this.truncateTags = val;
      }
    }
  },
  computed: {
    sortedTags() {
      if (!this.tags) return [];
      var tags = this.tags;
      tags = sortBy(tags, (t) => t.toLowerCase());
      if (this.truncateTags) {
        tags = tags.splice(0, this.limit)
      }
      return tags;
    },
  },
  methods: { sortBy },
};
</script>
